module.exports = __webpack_public_path__ + "img/tv-min.95dad419.png";